<app-dialog-header [header]="'button.generateReport' | loc"> </app-dialog-header>
<mat-dialog-content>
  <span> {{ 'header.reportType' | loc }}</span>
  <app-select-input [formControl]="reportTypeControl" [options]="options"> </app-select-input>
</mat-dialog-content>
<mat-dialog-actions class="centered">
  <button mat-stroked-button class="mat-primary submit-button button-rounded" type="button" (click)="generateReport()">
    {{ 'button.generateReport' | loc }}
  </button>
</mat-dialog-actions>
